export default __webpack_public_path__ + "static/media/office.acbe8527.webp";